import { gsap } from 'gsap';
import Observer from '../classes/Observer';

class Marquee extends Observer {
  constructor(el) {
    super({});
    this.$block = $(el);
    this.width = this.$block.width();
    this.speed = this.width / 150;

    this.animation = gsap.to(this.$block.get(0), {
      x: '-50%',
      duration: this.speed,
      paused: true,
      ease: 'none',
      repeat: -1,
    });

    this.observer.observe(this.$block.get(0));
  }

  animateIn() {
    this.animation.play();
  }

  animateOut() {
    this.animation.pause();
  }
}

export default Marquee;
